export default (billingProfileId, storeIntentRoute) => ({
  showLoginModal: false,
  
  async storeIntendedBillingProfile() {
    try {
      await window.axios.post(storeIntentRoute, {
        billing_profile_id: billingProfileId,
      });
    } catch (error) {
      console.error('Failed to store billing profile intent:', error);
    }
  },
});
